import * as Sentry from '@sentry/react'

export const errorCapture = (error) => {
  // Print error to console
  // eslint-disable-next-line no-console
  console.error(error)
  // Report to Sentry
  if (process.env.NODE_ENV === 'production') Sentry.captureException(error)
}
